(function () {
  'use strict';

  const predictiveSearch = document.getElementById('PredictiveSearch');
  const searchToggle = document.querySelector('[data-predictive-search-toggle]');
  const searchInput = document.querySelector('[data-predictive-search-input]');

  function openSearch() {
    if (!predictiveSearch) return;
    predictiveSearch.hidden = false;
    searchToggle && searchToggle.setAttribute('aria-expanded', 'true');
    searchInput && searchInput.focus();
  }
  function closeSearch() {
    if (!predictiveSearch) return;
    predictiveSearch.hidden = true;
    searchToggle && searchToggle.setAttribute('aria-expanded', 'false');
  }

  searchToggle &&
    searchToggle.addEventListener('click', () => {
      if (predictiveSearch.hidden) openSearch();
      else closeSearch();
    });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-predictive-search-close]')) closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  /* Keyboard support for mega menu */
  document.querySelectorAll('.site-header__nav-item.has-mega-menu').forEach((item) => {
    const link = item.querySelector('.site-header__nav-link');
    const menu = item.querySelector('.mega-menu');
    if (!link || !menu) return;
    link.addEventListener('focus', () => link.setAttribute('aria-expanded', 'true'));
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) {
        link.setAttribute('aria-expanded', 'false');
      }
    });
  });
})();
